import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { access, apiErrorSchema } from './schemas/common.js';
import { sourceSummarySchema, syncOutcomeSchema } from './schemas/domain.js';
const c = initContract();
export const sourcesContract = c.router({
    list: {
        method: 'GET',
        metadata: access('viewer'),
        path: '/sources',
        summary: 'Every registered source with its last health check',
        responses: {
            200: z.object({ sources: z.array(sourceSummarySchema) }),
        },
    },
    sync: {
        method: 'POST',
        metadata: access('admin'),
        path: '/sources/:sourceId/sync',
        summary: 'Run one sync pass now, and wait for it',
        pathParams: z.object({ sourceId: z.string().min(1) }),
        body: z.object({
            /** Overrides the stored cursor. Absent means "continue where we stopped". */
            since: z.iso.datetime().optional(),
        }),
        responses: {
            200: syncOutcomeSchema,
            404: apiErrorSchema,
            502: apiErrorSchema,
        },
    },
});
//# sourceMappingURL=sources.contract.js.map